export const SUPPORT_WHATSAPP_NUMBER = '966920007031';
export const WHATSAPP_BASE_URL = 'https://api.whatsapp.com/send';
